import { Dialog, Button, Typography } from "@material-tailwind/react";
import { t } from "i18next";
import { CubeIcon } from "@heroicons/react/24/outline";

interface DestockDialogProps {
  open: boolean;
  workorderRef: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const LoadingDots = () => (
  <div className="flex gap-1 items-center">
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_0ms]"></div>
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_200ms]"></div>
    <div className="w-1.5 h-1.5 bg-current rounded-full animate-[bounce_1s_infinite_400ms]"></div>
  </div>
);

export default function DestockDialog({
  open,
  workorderRef,
  onClose,
  onConfirm,
  loading = false,
}: DestockDialogProps) {

  // Empêcher la fermeture si en cours de chargement
  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  const buttonColor = "#DC2626"; // Sanguine brown 500 (même couleur que la bordure du bouton destock)

  return (
    <Dialog
      open={open}
      handler={handleClose}
      size="xs"
      dismiss={{
        enabled: !loading,
        outsidePress: !loading,
        escapeKey: !loading
      }}
    >
      <div className="p-4">
        <div className="flex items-center gap-3 mb-2">
          <div
            className="p-2 rounded-full"
            style={{ backgroundColor: buttonColor }}
          >
            <CubeIcon className="h-5 w-5 text-white" />
          </div>
          <Typography variant="h5">
            {t("workorder:action:destocked")} - #{workorderRef}
          </Typography>
        </div>
        <Typography className="mb-4">
          {t("workorder:odoo:confirmDestockText")}
        </Typography>
        <div className="flex justify-end gap-2">
          <Button
            onClick={handleClose}
            variant="outlined"
            color="blue-gray"
            size="sm"
            disabled={loading}
          >
            {t("Annuler")}
          </Button>
          <Button
            style={{ backgroundColor: buttonColor }}
            onClick={onConfirm}
            size="sm"
            disabled={loading}
            className="flex items-center justify-center min-w-[100px]"
          >
            {loading ? <LoadingDots /> : t("Confirmer")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
